module.exports = __webpack_public_path__ + "static/img/eu-logo.a6a0498.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/eu-logo.png
// module id = Tymz
// module chunks = 0